// extracted by mini-css-extract-plugin
export default {"settingsCard":"styles_settingsCard__77E-H","chevron":"styles_chevron__i85i2"};